var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faCalendarAlt, faLineColumns, faSearch, faTimes, faUndo } from "@fortawesome/pro-regular-svg-icons";
import { faDownload, faFilter, faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableViewComponent } from '@yodlee/common-components/dist/components';
import { Button, Checkbox, Col, DatePicker, Divider, Drawer, Icon, Input, Row, Spin, Tabs, Tooltip, Typography, message } from "antd";
import { uniqBy } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { SiteIcon } from "../../components/status";
import { StatusConfigs } from "../../configurations";
import { NotificationEnumns } from "../../types/enumerations";
import { DataUtils, NotfUtils } from "../../utilities";
import NotificationDetail from "../notification-detail";
import { saveAs } from "file-saver";
var siteAlertStatusMap = StatusConfigs.siteAlertStatusMap;
var TabPane = Tabs.TabPane;
var StatusSiteAlertList = function (_a) {
    var _b;
    var authentication = _a.authentication, onSitesListView = _a.onSitesListView, onSiteView = _a.onSiteView, isTier2 = _a.isTier2;
    var _c = useState("1"), activeKey = _c[0], setActiveKey = _c[1];
    var _d = useState(), siteAlertsCount = _d[0], setSiteAlertsCount = _d[1];
    var _e = useState(false), fetchingSummary = _e[0], setFetchingSummary = _e[1];
    var initialMountComplete = useRef(false);
    useEffect(function () {
        if (!initialMountComplete.current)
            return;
        fetchReportData();
    }, [(_b = authentication.selectedBrand) === null || _b === void 0 ? void 0 : _b.id]);
    useEffect(function () {
        fetchReportData();
        if (!initialMountComplete.current)
            initialMountComplete.current = true;
    }, []);
    var fetchReportData = function () {
        setFetchingSummary(true);
        DataUtils.reports(authentication).get({ view: "SITE_ALERT" }, true).then(function (response) {
            var countData = response === null || response === void 0 ? void 0 : response.siteAlerts;
            var upcomingCount = 0, activeCount = 0, resolvedCount = 0;
            (countData || []).forEach(function (countItem) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "IN-PROGRESS" || ((_b = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === "PARTIALLY FIXED") {
                    activeCount += ((_c = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _c !== void 0 ? _c : 0);
                }
                else if (((_d = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === "RESOLVED") {
                    resolvedCount += ((_e = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _e !== void 0 ? _e : 0);
                }
                else if (((_f = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === "UPCOMING") {
                    upcomingCount += ((_g = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _g !== void 0 ? _g : 0);
                }
                var finalCount = {
                    resolved: resolvedCount,
                    active: activeCount,
                    upcoming: upcomingCount
                };
                setSiteAlertsCount(finalCount);
            });
        }).catch(function () { return setSiteAlertsCount({ active: 0, resolved: 0, upcoming: 0 }); })
            .finally(function () { return setFetchingSummary(false); });
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(Typography.Text, { type: "secondary", className: "padding-left-xl" }, "Sites"),
            React.createElement(FontAwesomeIcon, { className: "margin-left-sm color-gray-5 cursor-pointer", icon: faLineColumns, onClick: onSitesListView })),
        React.createElement(Row, { style: { background: "white" } },
            React.createElement(Tabs, { className: "notf-list-tabs", activeKey: activeKey, onChange: function (activeKey) { return setActiveKey(activeKey); }, tabBarStyle: { fontWeight: "bold", color: "#757575", paddingLeft: 32 } },
                React.createElement(TabPane, { tab: React.createElement(React.Fragment, null,
                        "Active ",
                        fetchingSummary ? React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading", style: { margin: 0, paddingLeft: 1 } }) }) : React.createElement(React.Fragment, null,
                            "(",
                            (siteAlertsCount === null || siteAlertsCount === void 0 ? void 0 : siteAlertsCount.active) || 0,
                            ")")), key: "1" },
                    React.createElement(SiteAlertsTable, { isTier2: isTier2, onSiteView: onSiteView, appliedStatus: NotificationEnumns.SITE_ALERT_STATUS.ACTIVE, authentication: authentication })),
                React.createElement(TabPane, { tab: React.createElement(React.Fragment, null,
                        "Upcoming ",
                        fetchingSummary ? React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading", style: { margin: 0, paddingLeft: 1 } }) }) : React.createElement(React.Fragment, null,
                            "(",
                            (siteAlertsCount === null || siteAlertsCount === void 0 ? void 0 : siteAlertsCount.upcoming) || 0,
                            ")")), key: "2" },
                    React.createElement(SiteAlertsTable, { isTier2: isTier2, onSiteView: onSiteView, appliedStatus: NotificationEnumns.SITE_ALERT_STATUS.UPCOMING, authentication: authentication })),
                React.createElement(TabPane, { tab: React.createElement(React.Fragment, null,
                        "Resolved ",
                        fetchingSummary ? React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading", style: { margin: 0, paddingLeft: 1 } }) }) : React.createElement(React.Fragment, null,
                            "(",
                            (siteAlertsCount === null || siteAlertsCount === void 0 ? void 0 : siteAlertsCount.resolved) || 0,
                            ")"),
                        React.createElement(Tooltip, { placement: "bottomLeft", title: "Alerts in the last 7 days" },
                            React.createElement(FontAwesomeIcon, { className: "color-blue-5", size: "sm", style: { position: "relative", top: -4, left: 2 }, icon: faInfoCircle })),
                        " "), key: "3" },
                    React.createElement(SiteAlertsTable, { isTier2: isTier2, onSiteView: onSiteView, appliedStatus: NotificationEnumns.SITE_ALERT_STATUS.RESOLVED, authentication: authentication })))));
};
export default StatusSiteAlertList;
var initialPagination = {
    defaultPageSize: 25,
    defaultCurrent: 1,
    pageSizeOptions: ["25"],
    showSizeChanger: true,
    showQuickJumper: true,
    current: 1,
    pageSize: 25,
    total: 0
};
var SiteAlertsTable = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var authentication = _a.authentication, appliedStatus = _a.appliedStatus, onSiteView = _a.onSiteView, isTier2 = _a.isTier2;
    var _k = useState(), siteAlertDetails = _k[0], setSiteAlertDetails = _k[1];
    var _l = useState(), siteAlertList = _l[0], setSiteAlertList = _l[1];
    var _m = useState(initialPagination), pagination = _m[0], setPagination = _m[1];
    var _o = useState(), systemConfig = _o[0], setSystemConfig = _o[1];
    var _p = useState(false), filtersTouched = _p[0], setFiltersTouched = _p[1];
    var _q = useState(false), loadingMoreResults = _q[0], setLoadingMoreResults = _q[1];
    var searchFilterKeysRef = useRef({});
    var overriddenFilters = isTier2 ? { isPublish: true } : {};
    var failedImages = useRef({});
    var initialMountComplete = useRef(false);
    useEffect(function () {
        if (!initialMountComplete.current)
            return;
        getTableListData(pagination, searchFilterKeysRef.current);
    }, [(_b = authentication.selectedBrand) === null || _b === void 0 ? void 0 : _b.id]);
    useEffect(function () {
        DataUtils.systemConfig(authentication).get(undefined, true).then(function (response) {
            setSystemConfig(response);
        });
        getTableListData(initialPagination, searchFilterKeysRef.current);
        if (!initialMountComplete.current)
            initialMountComplete.current = true;
    }, []);
    var getTableListData = function (pagination, filters, incrementalPagination) {
        if (incrementalPagination === void 0) { incrementalPagination = false; }
        var pageSize = incrementalPagination ? pagination.defaultPageSize : pagination.pageSize;
        var pageNumber = incrementalPagination ? pagination.current : pagination.defaultCurrent;
        if (incrementalPagination)
            setLoadingMoreResults(true);
        else
            setSiteAlertList(undefined);
        // const isResolved = appliedStatus === NotificationEnumns.SITE_ALERT_STATUS.RESOLVED;
        var statusPreApplied = siteAlertStatusMap[appliedStatus];
        var formattedFilters = NotfUtils.filterFormatter(__assign(__assign({}, filters), { status: statusPreApplied, view: "status_page" }));
        DataUtils.siteAlerts(authentication).get(__assign(__assign({ pageNumber: pageNumber, pageSize: pageSize }, formattedFilters), overriddenFilters), true)
            .then(function (response) {
            setSiteAlertList(incrementalPagination ? __spreadArray(__spreadArray([], (siteAlertList || []), true), (response.data || []), true) : (response === null || response === void 0 ? void 0 : response.data) || []);
            setPagination(__assign(__assign({}, pagination), { total: response === null || response === void 0 ? void 0 : response.totalCount }));
        })
            .catch(function () {
            if (incrementalPagination) {
                setSiteAlertList(incrementalPagination ? (siteAlertList || []) : []);
            }
            else {
                setSiteAlertList([]);
                setPagination(__assign(__assign({}, pagination), { total: 0 }));
            }
        })
            .finally(function () {
            setLoadingMoreResults(false);
        });
    };
    var onExport = function () {
        var hide = message.loading('Preparing file...', 0);
        var statusPreApplied = siteAlertStatusMap[appliedStatus];
        var formattedFilters = NotfUtils.filterFormatter({ status: statusPreApplied, view: "status_page_export" });
        DataUtils.siteAlerts(authentication).get(__assign(__assign({}, formattedFilters), { isPublish: true, view: "status_page_export" }), true, true).then(function (resp) {
            saveAs(new Blob([resp], { type: "text/csv;charset=utf-8" }), "SiteAlerts - ".concat(appliedStatus, " - ").concat(moment(new Date()).format("Do MMM, YYYY"), ".csv"));
        }).finally(function () { return hide(); });
    };
    var searchBar = function (type) {
        if (type === void 0) { type = "FULL"; }
        return (React.createElement(Input, { allowClear: true, className: type === "COMPACT" ? "ghost-input" : "", autoFocus: type === "COMPACT", style: { width: type === "COMPACT" ? "100%" : undefined, maxWidth: type === "FULL" ? "300px" : undefined }, onChange: function (e) {
                if ((e.target.value || "").length === 0) {
                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), searchFilterKeysRef.current);
                }
            }, onPressEnter: function (e) {
                var _a, _b;
                var searchKey = (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
                if ((searchKey || "").length > 0) {
                    var isNumber = /^\d+$/.test(searchKey);
                    var keyToBeSearched = {};
                    if (isNumber)
                        keyToBeSearched = { siteId: searchKey };
                    else
                        keyToBeSearched = { siteName: searchKey };
                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), __assign(__assign({}, searchFilterKeysRef.current), keyToBeSearched));
                }
                else
                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), searchFilterKeysRef.current);
            }, suffix: React.createElement(React.Fragment, null, type === "COMPACT" &&
                React.createElement(Icon, { onClick: function () { }, className: "color-pink cursor-pointer", component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } })), prefix: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } }), placeholder: "Search by site ID or name" }));
    };
    var handleReset = function (clearFilters, key) {
        var _a;
        clearFilters();
        var newFilters = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = undefined, _a));
        searchFilterKeysRef.current = newFilters;
        getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newFilters);
    };
    var dateFilterProps = function (key, comparator, noOfDaysToEnable) {
        if (noOfDaysToEnable === void 0) { noOfDaysToEnable = 0; }
        return ({
            filterDropdown: function (_a) {
                var _b, _c;
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (React.createElement("div", null,
                    React.createElement("div", { className: "padding-xs" },
                        React.createElement(DatePicker, { value: selectedKeys && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) && moment(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) ?
                                moment(comparator === "after" ? (_b = selectedKeys[0]) === null || _b === void 0 ? void 0 : _b.from : (_c = selectedKeys[0]) === null || _c === void 0 ? void 0 : _c.to)
                                : undefined, onChange: function (dateRange) {
                                var _a;
                                var value = dateRange;
                                if (value) {
                                    setSelectedKeys(comparator === "after" ? [{ from: value.startOf("day").valueOf() }] : [{ to: value.endOf("day").valueOf() }]);
                                    var newSearchFilterKeys = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = comparator === "after" ? [{ from: value.startOf("day").valueOf() }] : [{ to: value.endOf("day").valueOf() }], _a));
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                }
                                else {
                                    setSelectedKeys(undefined);
                                    var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                    delete newSearchFilterKeys[key];
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                }
                            }, style: { marginBottom: 8, display: 'block' }, allowClear: true, disabledDate: function (current) { return noOfDaysToEnable && current && current < moment().subtract(noOfDaysToEnable, "day").endOf("day") ? true : false; }, format: "MMMM DD, YYYY", showToday: false, suffixIcon: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faCalendarAlt }); } }) })),
                    React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                    React.createElement(Row, { className: "padding-xs" },
                        React.createElement(Col, { span: 16, style: { textAlign: "right" } },
                            React.createElement(Button, { type: "link", className: "color-blue-5 cursor-pointer", onClick: function () {
                                    clearFilters();
                                    var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                    delete newSearchFilterKeys[key];
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                } },
                                React.createElement(FontAwesomeIcon, { icon: faUndo }),
                                React.createElement("span", { className: "margin-left-xs" }),
                                React.createElement("b", null, "Revert to default"))),
                        React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                            React.createElement(Button, { type: "primary", className: "cursor-pointer", onClick: function () {
                                    confirm();
                                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), searchFilterKeysRef.current);
                                } }, "Apply")))));
            },
            onFilter: function (value, record) { return true; },
            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
            filterMultiple: false,
            onClearFilter: function () { return handleReset(function () { }, key); },
        });
    };
    var alertDetailsView = React.createElement(Drawer, { width: "85vw", closable: false, visible: !!siteAlertDetails, onClose: function () { return setSiteAlertDetails(undefined); } },
        React.createElement(Row, null,
            React.createElement(FontAwesomeIcon, { onClick: function () { return setSiteAlertDetails(undefined); }, className: "color-gray-5 cursor-pointer", style: { float: "right", fontSize: 16 }, icon: faTimes })),
        siteAlertDetails && React.createElement(NotificationDetail, { onSiteIdClick: onSiteView, notfType: NotificationEnumns.NOTIFICATION_TYPE.SITE_ALERTS, id: siteAlertDetails === null || siteAlertDetails === void 0 ? void 0 : siteAlertDetails.id, authentication: authentication }));
    var columns = [
        {
            title: "Site ID",
            key: "siteId",
            dataIndex: "site.id",
            width: 100,
            minWidth: 100,
            ellipsis: true,
            sorter: function () { return 0; }
        },
        {
            title: "Name",
            key: "siteName",
            dataIndex: "site.name",
            width: 180,
            minWidth: 180,
            ellipsis: true,
            render: function (data, record) {
                var _a, _b, _c;
                return React.createElement(React.Fragment, null,
                    React.createElement(SiteIcon, { onError: function () {
                            var _a, _b, _c;
                            if (!((_a = failedImages.current) === null || _a === void 0 ? void 0 : _a[(_b = record === null || record === void 0 ? void 0 : record.site) === null || _b === void 0 ? void 0 : _b.id]))
                                failedImages.current[(_c = record === null || record === void 0 ? void 0 : record.site) === null || _c === void 0 ? void 0 : _c.id] = true;
                        }, logoUrl: systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.logoUrl, siteId: (_a = record === null || record === void 0 ? void 0 : record.site) === null || _a === void 0 ? void 0 : _a.id, loadDefault: (_b = failedImages.current) === null || _b === void 0 ? void 0 : _b[(_c = record === null || record === void 0 ? void 0 : record.site) === null || _c === void 0 ? void 0 : _c.id] }),
                    data);
            },
            sorter: function () { return 0; }
        },
        {
            title: "Alert ID",
            key: "id",
            dataIndex: "id",
            width: 150,
            minWidth: 150,
            sorter: function () { return 0; },
            ellipsis: true,
            render: function (id, record) {
                return React.createElement("span", { onClick: function () { return setSiteAlertDetails({ id: record === null || record === void 0 ? void 0 : record.id }); }, className: "color-blue-5 cursor-pointer" },
                    React.createElement(Tooltip, { placement: "bottomLeft", title: id },
                        React.createElement("b", null, id)));
            }
        },
        {
            title: "Issue Type",
            key: "issues",
            dataIndex: "issues",
            width: 150,
            minWidth: 150,
            ellipsis: true,
            filters: (__spreadArray(__spreadArray([], (((_e = (_d = (_c = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.siteAlert) === null || _c === void 0 ? void 0 : _c.categories) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.issues) || []), true), (((_h = (_g = (_f = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.siteAlert) === null || _f === void 0 ? void 0 : _f.categories) === null || _g === void 0 ? void 0 : _g[1]) === null || _h === void 0 ? void 0 : _h.issues) || []), true)).map(function (option) { return ({ text: option.name, value: option.searchId.toString() }); }),
            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
            onClearFilter: function () { return handleReset(function () { }, "issues"); },
            filterDropdown: function (_a) {
                var _b;
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                var filteredIssues = uniqBy(((_b = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.siteAlert) === null || _b === void 0 ? void 0 : _b.issues) || [], "searchId");
                return (React.createElement("div", null,
                    React.createElement("div", { className: "padding-xs", style: { maxHeight: 300, overflowY: "auto" } }, React.createElement(Checkbox.Group, { onChange: function (values) { return setSelectedKeys(values); }, value: selectedKeys }, (filteredIssues || []).map(function (opt, indx) {
                        return React.createElement(React.Fragment, { key: indx },
                            React.createElement(Checkbox, { className: "padding-bottom-xs", key: opt.name, value: opt.searchId }, opt.name),
                            React.createElement("br", null));
                    }))),
                    React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                    React.createElement(Row, { className: "padding-xs" },
                        React.createElement(Col, { span: 16 },
                            React.createElement(Button, { type: "link", onClick: function () {
                                    var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                    delete newSearchFilterKeys["issues"];
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                    clearFilters();
                                } },
                                React.createElement(FontAwesomeIcon, { icon: faUndo }),
                                React.createElement("span", { className: "margin-left-xs" }),
                                React.createElement("b", null, "Revert to default"))),
                        React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                            React.createElement(Button, { type: "primary", onClick: function () {
                                    var newSearchFilterKeys = __assign(__assign({}, searchFilterKeysRef.current), { "issues": selectedKeys });
                                    searchFilterKeysRef.current = newSearchFilterKeys;
                                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                    confirm();
                                } }, "Apply")))));
            },
            render: function (data) { return React.createElement("span", null,
                React.createElement(Tooltip, { placement: "bottomLeft", title: (data || []).map(function (itm) { return itm === null || itm === void 0 ? void 0 : itm.name; }).join(",\n") }, (data || []).map(function (itm) { return itm === null || itm === void 0 ? void 0 : itm.name; }).join(","))); },
        },
        {
            title: "Impact (As On)",
            key: "impact",
            dataIndex: "impact",
            width: 120,
            minWidth: 120,
            ellipsis: true,
            render: function (data, record) {
                return React.createElement(React.Fragment, null,
                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: React.createElement(React.Fragment, null,
                            data,
                            React.createElement("span", { className: "margin-left-xs" }),
                            "(",
                            record.impactAsOn ? moment(record.impactAsOn).calendar() : record.updated ? moment(record.updated).calendar() : '',
                            ")") },
                        data,
                        React.createElement("span", { className: "margin-left-xs" }),
                        "(",
                        record.impactAsOn ? moment(record.impactAsOn).calendar() : record.updated ? moment(record.updated).calendar() : '',
                        ")"));
            },
        },
        __assign(__assign({ title: "Estimated resolution", key: "tentativeETA", dataIndex: "tentativeETA", width: 180, minWidth: 180, ellipsis: true, render: function (data) {
                return React.createElement(React.Fragment, null,
                    React.createElement("span", null,
                        React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A")));
            } }, dateFilterProps("tentativeETA", "after", appliedStatus === NotificationEnumns.SITE_ALERT_STATUS.RESOLVED ? 8 : undefined)), { sorter: function () { return 0; } }),
        {
            title: "Updated",
            key: "updated",
            dataIndex: "updated",
            width: 180,
            minWidth: 180,
            render: function (data, record) {
                return React.createElement(React.Fragment, null,
                    React.createElement("span", null,
                        React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A")));
            },
            sorter: function () { return 0; },
            ellipsis: true
        },
    ];
    var formattedColumns = NotfUtils.formatColumns(columns, {}, undefined, filtersTouched);
    var isLastRecord = ((_j = (siteAlertList || [])) === null || _j === void 0 ? void 0 : _j.length) >= (pagination.total || initialPagination.total);
    return (systemConfig ? React.createElement("div", { id: "tbl-st-salrt", style: { position: "relative" } },
        React.createElement(TableViewComponent, { onClearAllFilter: function () {
                var sortFilters = { sortedBy: searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortedBy"], sortOrder: searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortOrder"] };
                searchFilterKeysRef.current = sortFilters;
                getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), sortFilters);
            }, suffix: searchBar(), extra: React.createElement(React.Fragment, null,
                React.createElement(Button, { type: "link", onClick: function () { return onExport(); } },
                    React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faDownload }); } }),
                    React.createElement("span", { className: "margin-left-xs" }),
                    "Export")), data: siteAlertList || [], footer: React.createElement(Col, { style: { textAlign: "center" }, className: "margin-top-xs" },
                React.createElement(Button, { loading: loadingMoreResults, disabled: isLastRecord, type: isLastRecord ? "link" : "default", size: isLastRecord ? "default" : "small", onClick: function () {
                        var newCurrentSize = (pagination.current || 1) + 1;
                        var newPagination = __assign(__assign({}, pagination), { current: newCurrentSize, pageSize: (pagination.pageSize || 0) + initialPagination.defaultPageSize });
                        getTableListData(newPagination, searchFilterKeysRef.current, true);
                        setPagination(newPagination);
                    } }, isLastRecord ? "You've reached the bottom of the page" : "Load more"),
                React.createElement("div", { style: { position: "absolute", right: 0, top: 0, padding: 8, fontWeight: "bold" } },
                    (siteAlertList || []).length,
                    "/",
                    pagination.total)), locale: { emptyText: "We can't find any site alerts." }, pagination: false, tableSetting: false, columns: formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.allColumns, fixedColumns: ["id"], loading: !siteAlertList, getRowKey: function (data) { return data.id; }, onChange: function (newPagination, filters, sorter) {
                var _a, _b;
                if (!filtersTouched)
                    setFiltersTouched(true);
                var hasSortOrderChanged = (searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortedBy"]) !== ((_a = sorter === null || sorter === void 0 ? void 0 : sorter.column) === null || _a === void 0 ? void 0 : _a.key) || (searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortOrder"]) !== (sorter === null || sorter === void 0 ? void 0 : sorter.order);
                var newFilters = __assign({}, searchFilterKeysRef.current);
                if (hasSortOrderChanged) {
                    newFilters = __assign(__assign({}, newFilters), { sortedBy: (_b = sorter === null || sorter === void 0 ? void 0 : sorter.column) === null || _b === void 0 ? void 0 : _b.key, sortOrder: sorter === null || sorter === void 0 ? void 0 : sorter.order });
                    searchFilterKeysRef.current = newFilters;
                }
                if (hasSortOrderChanged) {
                    getTableListData(__assign(__assign({}, pagination), newPagination), newFilters);
                }
            } }),
        alertDetailsView)
        :
            React.createElement(Row, { type: "flex", justify: "center", align: "middle", style: { height: "80vh" } },
                React.createElement(Col, null,
                    React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
};
//# sourceMappingURL=index.js.map